import React, { Component } from "react";
import {Helmet} from 'react-helmet'

interface Props {
    pageTitle?: string;
}

class PageHelmet extends Component<Props>{
    render(): React.ReactNode{
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle} - Personal Portfolio </title>
                    <meta name="description" content="Personal Portfolio" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
